import React from "react";

export type SendMoreProps = {
  /**
   * Width of the logo
   * if you overrides width + height, 'size' props will be ignored
   */
  width?: number;
  /**
   * Height of the logo
   * if you overrides width + height, 'size' props will be ignored
   */
  height?: number;
  /**
   * Choose between them value
   * @default black
   */
  color?: string;
  /**
   * The size of the logo
   * small: 122*46 | medium: 155*60 | large: 217*83
   * @default medium
   */
  size?: "small" | "medium" | "large";
};

const sizes = {
  small: {
    width: 34,
    height: 34,
  },
  medium: {
    width: 34,
    height: 34,
  },
  large: {
    width: 34,
    height: 34,
  },
};

export const SendMore: JSX.Element & any = React.forwardRef<
  SVGSVGElement,
  SendMoreProps
>((props, ref) => {
  const { size = "medium", width, height, color = "#fff" } = props;
  const svgSize = width && height ? { width, height } : sizes[size];
  return (
    <svg
      ref={ref}
      width={svgSize.width}
      height={svgSize.height}
      viewBox="0 0 23 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.9296 3.646L17.5023 7.2186M17.5023 7.2186L13.9296 10.7912M17.5023 7.2186H4.40269C2.42959 7.2186 0.830078 8.81812 0.830078 10.7912V12.5775"
        stroke={color}
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.18892 0.169434C5.25453 0.169434 4.49805 0.924955 4.49805 1.85953V4.83705H5.49805V1.85953C5.49805 1.47785 5.8062 1.16943 6.18892 1.16943H20.4794C20.8621 1.16943 21.1702 1.47785 21.1702 1.85953V12.5704C21.1702 12.952 20.8621 13.2605 20.4794 13.2605H15.7159C15.5487 13.2605 15.3927 13.344 15.2999 13.483L13.3341 16.4298L11.3683 13.483C11.2756 13.344 11.1195 13.2605 10.9524 13.2605H6.18892C5.8062 13.2605 5.49805 12.952 5.49805 12.5704V9.60053H4.49805V12.5704C4.49805 13.5049 5.25453 14.2605 6.18892 14.2605H10.6849L12.9182 17.6082C13.0109 17.7472 13.167 17.8307 13.3341 17.8307C13.5013 17.8307 13.6573 17.7472 13.7501 17.6082L15.9834 14.2605H20.4794C21.4137 14.2605 22.1702 13.5049 22.1702 12.5704V1.85953C22.1702 0.924955 21.4137 0.169434 20.4794 0.169434H6.18892Z"
        fill={color}
      />
    </svg>
  );
});

SendMore.displayName = "SendMore";
